import { useEffect, useState } from 'react';
import TimesheetApp from '../components/timesheet/TimesheetApp';
import AdminApp from './admin/AdminApp';
import { app } from "@microsoft/teams-js";
import { msalInstance } from '../services/MSALConfig';
import { ProtectedApp } from './ProtectedApp';

function App() {
  const [teamsReady, setTeamsReady] = useState(false);
  const [entityId, setEntityId] = useState(null);

  useEffect(() => {
  msalInstance
    .handleRedirectPromise()
    .then((response) => {
      if (response) {
        console.log("Redirect login successful:", response.account);
      }
    })
    .catch((error) => {
      console.error("Redirect error:", error);
    });
}, []);

  useEffect(() => {
  app.initialize().then(() => {
    app.getContext().then((context) => {
        if (context) {
            console.log("Running in Microsoft Teams."); // teams
            setEntityId(context.page.id);
            setTeamsReady(true);
        } else {
          console.log("Running in a standard browser (Teams context not available)."); // browser
          setTeamsReady(true);
        }
    });
  }).catch((error) => {
      console.log("Running in a standard browser (Teams SDK not initialized).");
      setTeamsReady(true);
  });
  }, []);
  
  if (!teamsReady) return <div>Loading context...</div>;

  if (!entityId) return (<ProtectedApp><TimesheetApp/></ProtectedApp>);
  if (entityId === "personal") return (<AdminApp/>);
  return <TimesheetApp/>;
}

export default App;